import { DEFAULT_LOCALE, has, interpolate, tIn } from '../../i18n';
import type { Locale } from '../../domain/types';
import { FALLBACK_TEXT_HE, type TemplateCall } from './templates';

/**
 * Renders a template to WhatsApp-style text. Uses `messages.<template>` from the UX locale files when
 * present, otherwise the built-in Hebrew fallback (the outbox never shows raw keys).
 */
export function renderTemplate(call: TemplateCall, locale: Locale = DEFAULT_LOCALE): string {
  const key = `messages.${call.template}`;
  const params = call.params as Record<string, string>;
  return has(key, locale) ? tIn(locale, key, params) : interpolate(FALLBACK_TEXT_HE[call.template], params);
}
